var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconRevisao = function SvgIconRevisao(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.5C11.209 3.5 13 5.291 13 7.5C13 9.709 11.209 11.5 9 11.5C6.791 11.5 5 9.709 5 7.5C5 5.291 6.791 3.5 9 3.5ZM9 5.5C7.8955 5.5 7 6.3955 7 7.5C7 8.6045 7.8955 9.5 9 9.5C10.1045 9.5 11 8.6045 11 7.5C11 6.3955 10.1045 5.5 9 5.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9522 7.95244C18.2609 7.64604 18.6747 7.33529 19.1875 7.15547C18.7428 6.74839 18.1504 6.5 17.5 6.5C16.1194 6.5 15 7.61938 15 9C15 9.53866 15.1704 10.0375 15.4602 10.4457L17.9472 7.95739L17.9522 7.95244Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5C12.1355 13.5 12.2675 13.5043 12.3961 13.5129L10.4112 15.5H6.00373C4.72134 15.5 4.0545 16.4216 4.00321 18.2648L4 18.5H9.15381L9.03105 19.0833L9.02101 19.166C8.97924 19.5098 8.98461 20.0079 9.18009 20.5H4C2.66667 20.5 2 19.8333 2 18.5C2 15.1667 3.33458 13.5 6.00373 13.5H12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9885 18.1137L21.1494 14.9507C21.7169 15.779 22.0005 16.9621 22 18.5C22 19.8333 21.3333 20.5 20 20.5H17.0158C17.601 20.5 17.9252 19.7046 17.9885 18.1137Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.83 9.39118C20.3108 8.87016 19.7893 8.86961 19.2657 9.38952L17.7036 10.9531L20.0473 13.2999L21.6093 11.7363C22.1302 11.2148 22.1302 10.6937 21.6093 10.1716C21.2189 9.78008 21.219 9.78077 21.219 9.78077C21.219 9.78077 21.2192 9.78146 20.83 9.39118Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3613 13.9874L17.0176 11.6406L11.4543 17.2115L11.0085 19.3304C10.9765 19.5942 11.0345 19.7773 11.1825 19.8802C11.253 19.9305 11.3328 19.966 11.4173 19.9848C11.5017 20.0035 11.5891 20.005 11.6741 19.9891L13.7974 19.5577L19.3613 13.9874Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRevisao, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-revisao.b1f6ff3a.svg";
export { ForwardRef as ReactComponent };